// @flow

import React from "react";

type Props = {
  size?: number
};

const ActiveCheckbox = ({ size = 24 }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${size}px`}
    height={`${size}px`}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#2F80ED"
      d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
    />
  </svg>
);

export default ActiveCheckbox;
